module.exports = __webpack_public_path__ + "img/pic_new_features_2.61427330.png";